import Container from './TreeManager.container';

export default Container;
